import React, { Component } from 'react';
import {
  map, indexOf, concat, without, each, findIndex, filter,
} from 'lodash';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { pushTvTagMappings, pushTvTagMappingsStreaming } from '../../SetupActions';
import CollectorIndicator from './CollectorIndicator';
import PathDisplay from '../../../../components/search-path/path';
import ProgramType from '../../../../components/program-type';
import NumberDisplay from '../../../../components/number-display';
import Counter from '../../../../components/counter';

const USE_SOCKET = true;
class ApplyTagModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.field !== null,
      field: props.field,
      loading: false,
      submitted: false,
      submittedId: null,
      submittedCollectors: [],
      selectedCollectors: [],
      allDone: false,
    };
    this.close = this.close.bind(this);
    this.apply = this.apply.bind(this);
    this.toggleCollector = this.toggleCollector.bind(this);
    this.viewResults = this.viewResults.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.field !== null && this.props.field === null) {
      this.setState({
        show: true,
        field: nextProps.field,
        selectedCollectors: map(nextProps.collectors, c => `${c.collector_type}|${c.collector_id}`),
        submitted: false,
        submittedId: null,
        submittedCollectors: [],
      });
    } else if (nextProps.field === null && this.props.field !== null) {
      this.setState({ show: false });
    }
  }

  toggleCollector(collector) {
    const id = `${collector.collector_type}|${collector.collector_id}`;
    const i = indexOf(this.state.selectedCollectors, id);
    if (i >= 0) {
      this.setState({ selectedCollectors: without(this.state.selectedCollectors, id) });
    } else {
      this.setState({ selectedCollectors: concat(this.state.selectedCollectors, [id]) });
    }
  }


  applyViaSocket() {
    const fields = [this.props.field._id];
    this.props.dispatch(pushTvTagMappings({ collectors: this.state.selectedCollectors, fields }))
      .then(
        ({ id, collectors }) => {
          this.setState({
            loading: false,
            submitted: true,
            submittedId: id,
            submittedCollectors: collectors,
          });
        },
        (e) => {
          console.log(e);
          this.setState({ loading: false });
        },
      );
  }

  applyViaStreaming() {
    const { collectors } = this.props;
    const fields = [this.props.field._id];

    // const allChunks = [];
    const { submittedCollectors } = this.state;
    // currently there is only 1 field can be pushed at a time
    const isContactField = this.props.field?.type === 'Contact';
    let initialized = false;
    const cb = (err, chunk) => {
      each(chunk, (c) => {

        // each c will also contain valid collectors array
        if (!initialized) {
          initialized = true; // only need to do this once
          each(c.collectors, (validCollector) => {
            const existentIndex = findIndex(submittedCollectors, { id: validCollector.id });
            if (existentIndex < 0) {
              const collectorInfoIndex = findIndex(collectors, {
                collector_id: validCollector.collector_id, collector_type: validCollector.collector_type, program_id: validCollector.program_id
              });
              let submittedCollector = submittedCollectors[existentIndex];
              if (!submittedCollector) {
                submittedCollector = {
                  ...collectors[collectorInfoIndex],
                  id: validCollector.id,
                  total: 0,
                  current: 0,
                  done: false,
                  items: [],
                };
                submittedCollectors.push(submittedCollector);
              }
            }
          });
        }

        const existentIndex = findIndex(submittedCollectors, { id: c.id });
        if (existentIndex >= 0) {
          const submittedCollector = submittedCollectors[existentIndex];
          submittedCollector.current = c.current;
          submittedCollector.total = c.total;
          submittedCollector.done = c.done;
          each(c.chunk, (item) => {
            if (isContactField) {
              // flatten items, if contact tag is used
              each(item.contacts, (contact) => {
                submittedCollector.items.push({
                  opportunity_id: item.opportunity_id,
                  account_id: item.account_id,
                  ...contact,
                  contact_name: contact.name,
                  name: item.name,
                  id: `${item.opportunity_id}|${contact.contact_id}`,
                });
              });
            } else {
              submittedCollector.items.push({
                id: item.opportunity_id,
                ...item,
              });
            }
          });
        }
      });

      const allDone = indexOf(submittedCollectors, { done: false }) < 0;

      this.setState({
        loading: false,
        submitted: true,
        allDone,
        // submittedId,
        submittedCollectors: [...submittedCollectors],
      });
    };

    this.props.dispatch(pushTvTagMappingsStreaming({ collectors: this.state.selectedCollectors, fields }, cb))
      .then(
        () => {
          
        },
        (e) => {
          // TODO: need to simulate this
          console.log(e);
          this.setState({ loading: false });
        },
      );
  }

  apply() {
    if (this.loading) {
      return;
    }
    this.setState({ loading: true, allDone: false }, () => {
      if (USE_SOCKET)  {
        this.applyViaSocket();
      } else {
        this.applyViaStreaming();
      }
    });
  }

  viewResults(collector) {
    this.props.showResults(collector);
  }


  close() {
    this.setState({ selectedCollectors: [], submitted: false });
    this.props.onClose();
  }

  renderResultModal() {
    const {
      field,
      submittedId, submittedCollectors,
    } = this.state;
    const hasManyCollectors = submittedCollectors && submittedCollectors.length !== 1;
    return (
      <Modal show={this.state.show} onHide={this.close}>
        <Modal.Header closeButton>
          <h4>Tag Applied</h4>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p>Applying <PathDisplay startingNode={field.type} paths={field.field} skipMetaCheck={!field.accessible}/> values as TruVoice tags in the following collector{(hasManyCollectors ? 's' : '')}:</p>
            {submittedCollectors.map((submittedCollector) => {
              return (
                <CollectorIndicator
                  key={`${submittedId}::${submittedCollector.collector_type}::${submittedCollector.collector_id}`}
                  eventName={`tvPushTags::${submittedId}`}
                  collector={submittedCollector}
                />
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.close} bsStyle="default">Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderType(type) {
    return (<ProgramType type={type} />);
  }

  render() {
    const {
      field, loading,
      submitted, submittedCollectors, allDone,
    } = this.state;
    const hasField = field !== null;
    const { collectors } = this.props;
    const hasCollector = collectors !== null && collectors.length > 0;
    const hasManyCollectors = collectors !== null && collectors.length > 1;
    const hasSelected = this.state.selectedCollectors.length > 0;
    if (submitted && USE_SOCKET) {
      return this.renderResultModal();
    }

    const _loading = loading || (USE_SOCKET && submitted);

    return (
      <Modal bsSize="lg" show={this.state.show} onHide={this.close}>
        <Modal.Header closeButton>
          <h4>Apply Tag</h4>
        </Modal.Header>
        <Modal.Body>
          {hasField &&
            <div>
              {!hasCollector && <div className="alert alert-danger">No Collector Found.</div>}
              {hasCollector &&
                <div>
                  <p>Apply the <PathDisplay startingNode={field.type} paths={field.field} /> values as TruVoice tags to all opportunities that have been previously submitted to the following Truvoice collector{(hasManyCollectors ? 's' : '')}:</p>
                  <table className="table table-condensed table-striped">
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <th>Collector</th>
                        <th>Collector Type</th>
                        <th>Initiative</th>
                        <th>Program Type</th>
                        {submitted && <th>Results</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {(submitted ? submittedCollectors : collectors).map((collector) => {
                        const id = `${collector.collector_type}|${collector.collector_id}`;
                        const active = indexOf(this.state.selectedCollectors, id) >= 0;
                        let result = null;
                        const { done } = collector;
                        if (submitted) {
                          const { total, current, items } = collector;
                          let percentage = total > 0 ? current / total : 0;
                          if (done) {
                            percentage = 1;
                          }
                          result = (
                            <span className="animated flash infinite">
                              <Counter value={percentage * 100}>
                                <NumberDisplay value={percentage * 100} precision={percentage < 1 ? 2 : 0} suffix="%" />
                              </Counter>
                            </span>
                          );

                          if (done) {
                            if (items.length > 0) {
                              result = (
                                <Button bsSize="xs" bsStyle="default" onClick={() => { this.viewResults(collector); }}>View Results</Button>
                              );
                            } else {
                              result = (
                                <Button bsSize="xs" bsStyle="default" disabled>No Results</Button>
                              );
                            }
                          }
                        }
                        return (
                          <tr key={id}>
                            <td className="text-center">
                              {!submitted &&
                                <a
                                  href=""
                                  onClick={(e) => { e.preventDefault(); this.toggleCollector(collector); }}
                                >
                                  <Fa name={active ? 'check-square' : 'square-o'} className={active ? 'text-success' : 'text-muted'} />
                                </a>
                              }
                              {(submitted && active) && 
                                <span>
                                  {done && <Fa name="check-circle" className="text-success" />}
                                  {!done && <Fa name="spinner" spin />}
                                </span>
                              }
                              {(submitted && !active) && 
                                <Fa name="square-o" className="text-muted" />
                              }
                            </td>
                            <td>
                              {!active && collector.collector_name}
                              {active && <strong>{collector.collector_name}</strong>}
                            </td>
                            <td>
                              <span className="label label-default text-uppercase">{collector.collector_type}</span>
                            </td>
                            <td>
                              {collector.program !== null && (<span>{collector.program.name}</span>)}
                            </td>
                            <td>
                              {collector.program !== null && (<span>{this.renderType(collector.program.type_name)}{collector.program.type_name}</span>)}
                            </td>
                            {submitted && <td>{result}</td>}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              }
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          {(!hasField || !hasCollector) && <Button onClick={this.close} bsStyle="default">Cancel</Button>}
          {(hasField && hasCollector) &&
            <div className="clearfix">
              <Button className="pull-right" onClick={this.apply} bsStyle="primary" disabled={(_loading || !hasSelected || submitted)}>
                <Fa name={(_loading ? 'spinner' : 'upload')} spin={_loading} /> Apply Tag
              </Button>
            </div>
          }
        </Modal.Footer>
      </Modal>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
  };
}

ApplyTagModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  field: PropTypes.shape({
    _id: PropTypes.string,
    type: PropTypes.string,
    field: PropTypes.arrayOf(PropTypes.string),
  }),
  onClose: PropTypes.func,
  collectors: PropTypes.arrayOf(PropTypes.shape({})),
  showResults: PropTypes.func,
};

ApplyTagModal.defaultProps = {
  onClose: () => {},
  data: null,
  collectors: [],
  showResults: () => {},
};

export default connect(mapStateToProps)(ApplyTagModal);
